
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 2","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16.63 16.66"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.12 4.82c0-2.71-2.24-4.9-4.96-4.82-2.54.07-4.64 2.21-4.67 4.75a4.81 4.81 0 002.09 4.03 8.341 8.341 0 00-3.17 1.99A8.304 8.304 0 000 15.95c-.03.38.27.71.65.71.33 0 .62-.25.64-.59.3-3.6 3.33-6.44 7-6.44 2.66 0 4.82-2.16 4.82-4.82zM8.3 8.33c-1.94 0-3.51-1.58-3.51-3.51S6.37 1.31 8.3 1.31s3.51 1.58 3.51 3.51-1.58 3.51-3.51 3.51zm2.8 4.42h4.88c.36 0 .65.29.65.65 0 .36-.29.65-.65.65H11.1c-.36 0-.65-.29-.65-.65 0-.36.29-.65.65-.65zm5.53-1.95c0 .36-.29.65-.65.65H11.1c-.36 0-.65-.29-.65-.65 0-.36.29-.65.65-.65h4.88c.36 0 .65.29.65.65zm-5.53 4.56h4.88c.36 0 .65.29.65.65 0 .36-.29.65-.65.65H11.1c-.36 0-.65-.29-.65-.65 0-.36.29-.65.65-.65z","data-name":"Layer 1"}})])
          )
        }
      }
    